<script>
	const params = new URLSearchParams(window.location.search)
	export let members_s = params.has("members") ? decodeURIComponent(params.get("members")).replace("#", "").replaceAll("|", "\n") : ""
	export let week_s = params.has("week") ? params.get("week") : "1";
	$: members_list = members_s.split("\n").filter(s => s.length > 0)
	$: week = parseInt(week_s)
	$: permalink = "?members=" + members_list.join("|") + "&week=" + week
	$: sn = week % members_list.length
	$: fixed = members_list.length % 2 == 0 ? members_list.shift() : null
	$: members = [fixed].concat(...members_list.slice(sn).concat(members_list.slice(0,sn)))
	$: members_r = members.slice(0, Math.round(members.length/2))
	$: members_l = members.slice(Math.round(members.length/2)).reverse()
	$: member_pairs = members_r.map((r, i) => [r, members_l[i]])
</script>

<main>
	<h1>Pairing Rotation</h1>
	<h2>Team Members:</h2>
	<textarea bind:value={members_s} rows={members_list.length}/>
	<h2>Week:</h2>
	<p><input type="number" bind:value={week_s} /></p>
	<h2>This Week's Pairs:</h2>
	<p><a href={permalink}>(Permalink)</a></p>
	<table>
		{#each member_pairs as pair}
			<tr>
				<td>{pair[0] ? pair[0] : "[off]"}</td>
				<td>{pair[1] ? pair[1] : "[off]"}</td>
			</tr>
		{/each}
	</table>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 100;
	}

	h2 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 1.5em;
		font-weight: 100;
	}

	table {
		width: 40%;
		margin: auto;
	}

	table td {
		width: 40%;
	}

	table tr {
		font-size: 1.2em;
		background: #feefef;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>